import { render, staticRenderFns } from "./CurrentSharingButton.vue?vue&type=template&id=5d962c4f&scoped=true&"
import script from "./CurrentSharingButton.vue?vue&type=script&lang=js&"
export * from "./CurrentSharingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d962c4f",
  null
  
)

export default component.exports